/* ============================================================
   EUTEYIA - Quick-add popup (sélection produit sur les cartes)
   Réplique fidèlement la FICHE PRODUIT : on lève les blocs
   d'affichage de la page produit (titre+étoile, badge, étoiles
   +vendus) et on reconstruit prix / swatches avec les classes du
   thème -> rendu identique, par produit. Angles droits.
   Desktop = modale centrée (image gauche) ; mobile = bottom sheet.
   ============================================================ */
(function () {
  "use strict";
  if (window.__euqLoaded) return; window.__euqLoaded = true;

  function euros(cents) { var v = cents / 100; var s = (v % 1 === 0) ? String(v) : v.toFixed(2).replace(".", ","); return s + "€"; }
  function isColorOpt(name) { return /couleur|color|colour|finition/i.test(name || ""); }
  var COLORS = { "or": "rgb(212,154,6)", "gold": "rgb(212,154,6)", "argent": "rgb(211,211,211)", "silver": "rgb(211,211,211)", "noir": "#1a1a1a", "black": "#1a1a1a", "rose": "#e8a87c", "blanc": "#f2f2f2" };
  function swatchColor(val, colorMap) { var m = colorMap && colorMap[val]; if (m && m.style) { var mm = /--option-color:\s*([^;]+)/.exec(m.style); if (mm) return mm[1].trim(); } return COLORS[String(val).toLowerCase()] || "#dcdcdc"; }
  function swatchClass(val, colorMap) { if (colorMap && colorMap[val] && colorMap[val].cls) return colorMap[val].cls; var v = String(val).toLowerCase(); if (/or|gold|dor/.test(v)) return "eut-swatch-gold"; if (/argent|silver/.test(v)) return "eut-swatch-silver"; return ""; }

  /* ---------- CSS ---------- */
  var css =
    "#euq-root *{box-sizing:border-box}" +
    "#euq-root{--eut-ink:#151515;--eut-panel:#fff;--eut-fd:'Bicyclette','Helvetica Neue',Arial,sans-serif}" +
    "#euq-backdrop{position:fixed;inset:0;z-index:2147482500;background:rgba(20,20,20,.5);backdrop-filter:saturate(120%) blur(3px);-webkit-backdrop-filter:saturate(120%) blur(3px);opacity:0;transition:opacity .25s;display:flex;align-items:center;justify-content:center;padding:24px}" +
    "#euq-backdrop.euq-on{opacity:1}" +
    "#euq-panel{position:relative;background:#fff;width:100%;max-width:920px;max-height:88vh;display:flex;flex-direction:column;overflow:hidden;box-shadow:0 30px 90px rgba(0,0,0,.28);transform:translateY(14px) scale(.985);transition:transform .28s cubic-bezier(.2,.8,.2,1);border-radius:0}" +
    "#euq-body{display:flex;flex:1 1 auto;min-height:0;width:100%}" +
    "#euq-backdrop.euq-on #euq-panel{transform:none}" +
    "#euq-close{position:absolute;top:14px;right:14px;z-index:3;width:34px;height:34px;border-radius:50%;border:0;background:rgba(255,255,255,.9);cursor:pointer;font-size:17px;line-height:34px;text-align:center;color:#222;box-shadow:0 2px 10px rgba(0,0,0,.12)}" +
    "#euq-close:hover{background:#fff}" +
    /* ---- media carousel ---- */
    ".euq-media{flex:0 0 46%;position:relative;background:#f5f4f2;overflow:hidden;align-self:stretch;min-height:360px}" +
    ".euq-track{display:flex;height:100%;width:100%;overflow-x:auto;scroll-snap-type:x mandatory;scroll-behavior:smooth;scrollbar-width:none;-ms-overflow-style:none}" +
    ".euq-track::-webkit-scrollbar{display:none}" +
    ".euq-slide{flex:0 0 100%;width:100%;height:100%;min-height:360px;scroll-snap-align:center}" +
    ".euq-slide img{width:100%;height:100%;object-fit:cover;display:block}" +
    ".euq-nav{position:absolute;top:50%;transform:translateY(-50%);width:34px;height:34px;border-radius:4px;background:rgba(255,255,255,.9);border:1px solid rgba(0,0,0,.06);cursor:pointer;font-size:15px;line-height:32px;text-align:center;color:#111;box-shadow:0 1px 5px rgba(0,0,0,.08);z-index:2;padding:0;transition:background .15s}" +
    ".euq-nav:hover{background:#fff}" +
    ".euq-prev{left:12px}.euq-next{right:12px}" +
    ".euq-progress{position:absolute;left:0;right:0;bottom:0;height:2px;background:rgba(0,0,0,.08);z-index:2}" +
    ".euq-progress__bar{position:absolute;top:0;bottom:0;left:0;width:0;background:rgba(30,30,30,.5);transition:width .3s cubic-bezier(.4,0,.2,1)}" +
    /* ---- info ---- */
    ".euq-info{flex:1 1 54%;padding:22px 32px 22px;overflow-y:auto;display:flex;flex-direction:column;min-height:0}" +
    ".euq-eyebrow{font-size:12.5px;letter-spacing:.14em;text-transform:uppercase;color:#9a9a9a;font-weight:500;margin:0 0 4px}" +
    ".euq-info .product-title{margin:0 0 6px;font-size:28px!important;line-height:1.1}" +
    ".euq-title-link{display:block;color:inherit;text-decoration:none;cursor:pointer}" +
    ".euq-info .product-best-seller-badge{margin:0 0 7px}" +
    ".euq-info .eut-social-proof{margin:0 0 9px}" +
    ".euq-info .product-price-container{margin:0 0 14px}" +
    ".euq-info .product-price-container .amount{font-weight:700}" +
    ".euq-was{color:#a2a2a2;text-decoration:line-through;font-weight:400;margin-right:6px}" +
    ".euq-sw{display:flex;gap:14px;flex-wrap:wrap;padding:2px 0}" +
    ".euq-sw button{position:relative;width:28px;height:28px;border-radius:999px;border:0;background:none;padding:0;cursor:pointer}" +
    ".euq-sw button::after{content:'';position:absolute;inset:0;border-radius:999px;background:var(--option-color)}" +
    ".euq-sw button.eut-swatch-gold::after{background:linear-gradient(45deg,rgb(244,239,227),rgb(239,227,194) 28%,rgb(229,209,154) 55%,rgb(215,190,123) 78%,rgb(201,174,103))}" +
    ".euq-sw button.eut-swatch-silver::after{background:linear-gradient(45deg,rgb(159,159,159),rgb(183,183,183) 20%,rgb(217,217,217) 42%,rgb(240,240,240),rgb(207,207,207) 70%,rgb(169,169,169))}" +
    ".euq-sw button::before{content:'';position:absolute;inset:-4px;border-radius:999px;border:1.5px solid transparent;transition:border-color .15s}" +
    ".euq-sw button[aria-pressed=true]::before{border-color:#111}" +
    ".euq-opt{margin:0 0 18px}" +
    ".euq-opt__label{font-size:12px;color:#767676;margin:0 0 8px}" +
    ".euq-opt__label b{color:#141414;font-weight:600}" +
    ".euq-pills{display:flex;gap:8px;flex-wrap:wrap}" +
    ".euq-pills button{border:1px solid #d9d9d9;background:#fff;color:#222;border-radius:6px;padding:10px 14px;font-size:13px;cursor:pointer;transition:.15s;font-weight:500}" +
    ".euq-pills button[aria-pressed=true]{border-color:#141414;background:#141414;color:#fff}" +
    ".euq-pills button[disabled]{opacity:.4;text-decoration:line-through;cursor:not-allowed}" +
    ".euq-actions{display:flex;gap:12px;align-items:center;margin-top:auto;padding-top:6px}" +
    ".euq-actions .single-add-to-cart-button{flex:1 1 auto;border-radius:5px}" +
    ".euq-actions .wishlist-btn--pdp{flex:0 0 auto}" +
    ".euq-qty{display:flex;align-items:center;border:1px solid #dcdcdc;border-radius:0;overflow:hidden;flex:0 0 auto}" +
    ".euq-qty button{width:40px;height:54px;border:0;background:#fff;font-size:18px;cursor:pointer;color:#222}" +
    ".euq-qty button:hover{background:#f6f6f6}" +
    ".euq-qty input{width:38px;height:54px;border:0;text-align:center;font-size:15px;-moz-appearance:textfield}" +
    ".euq-qty input::-webkit-outer-spin-button,.euq-qty input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}" +
    ".euq-add{flex:1 1 auto;border:0;background:#151515;color:#fff;border-radius:0;font-size:13px;font-weight:700;letter-spacing:.07em;text-transform:uppercase;cursor:pointer;min-height:54px;font-family:inherit;transition:opacity .15s}" +
    ".euq-add:hover{opacity:.88}" +
    ".euq-add[disabled]{background:#bdbdbd;cursor:not-allowed}" +
    ".euq-add.euq-added{background:#2f7d55}" +
    ".euq-details{display:inline-block;margin-top:16px;font-size:12.5px;color:#141414;text-decoration:underline;text-underline-offset:2px}" +
    ".euq-spin{display:inline-block;width:15px;height:15px;border:2px solid rgba(255,255,255,.5);border-top-color:#fff;border-radius:50%;animation:euqspin .7s linear infinite;vertical-align:-2px}" +
    "@keyframes euqspin{to{transform:rotate(360deg)}}" +
    /* ---- mobile : bottom sheet ---- */
    "@media(max-width:749px){" +
    "#euq-backdrop{align-items:flex-end;padding:0}" +
    "#euq-panel{max-width:100%;max-height:92vh;flex-direction:column;border-radius:0;transform:translateY(100%)}" +
    "#euq-backdrop.euq-on #euq-panel{transform:none}" +
    "#euq-body{flex-direction:column;overflow-y:auto}" +
    ".euq-media{flex:0 0 auto;min-height:0;height:44vh}" +
    ".euq-slide{min-height:0}" +
    ".euq-info{padding:22px 20px calc(22px + env(safe-area-inset-bottom))}" +
    ".euq-info .product-title{font-size:22px!important}" +
    ".euq-nav{display:none}" +
    "}";

  /* ---------- DOM shell ---------- */
  var root, backdrop, panel, body;
  function ensureShell() {
    if (root) return;
    var st = document.createElement("style"); st.id = "euq-css"; st.textContent = css; document.head.appendChild(st);
    root = document.createElement("div"); root.id = "euq-root";
    root.innerHTML =
      '<div id="euq-backdrop" role="dialog" aria-modal="true" aria-label="Sélection du bijou">' +
        '<div id="euq-panel"><button id="euq-close" aria-label="Fermer">✕</button><div id="euq-body"></div></div>' +
      '</div>';
    document.body.appendChild(root);
    backdrop = root.querySelector("#euq-backdrop");
    panel = root.querySelector("#euq-panel");
    body = root.querySelector("#euq-body");
    backdrop.addEventListener("click", function (e) { if (e.target === backdrop) close(); });
    root.querySelector("#euq-close").addEventListener("click", close);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && backdrop.classList.contains("euq-on")) close(); });
  }
  function open() { ensureShell(); backdrop.style.display = "flex"; document.documentElement.style.overflow = "hidden"; setTimeout(function () { backdrop.classList.add("euq-on"); }, 20); }
  function close() { if (!backdrop) return; clearInterval(autoTimer); backdrop.classList.remove("euq-on"); document.documentElement.style.overflow = ""; setTimeout(function () { backdrop.style.display = "none"; }, 280); }

  /* ---------- helpers variantes ---------- */
  var CUR = null, autoTimer;
  function findVariant(p, sel) { return p.variants.filter(function (v) { for (var i = 0; i < sel.length; i++) if (String(v.options[i]) !== String(sel[i])) return false; return true; })[0] || null; }
  function optionAvailable(p, optIdx, value, sel) { return p.variants.some(function (v) { if (String(v.options[optIdx]) !== String(value)) return false; for (var i = 0; i < sel.length; i++) if (i !== optIdx && String(v.options[i]) !== String(sel[i])) return false; return v.available; }); }
  function priceMarkup(cents, cmp) {
    var s = '<span class="price' + (cmp && cmp > cents ? ' price--on-sale' : '') + '">';
    if (cmp && cmp > cents) s += '<s class="euq-was">' + euros(cmp) + '</s>';
    s += '<ins><span class="amount">' + euros(cents) + '</span></ins></span>';
    return s;
  }

  /* ---------- Rendu produit (p = json, doc = HTML fiche produit) ---------- */
  function render(p, doc) {
    var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    var sel = first.options.slice();
    CUR = { product: p, selected: sel };
    function norm(u) { return u ? (u.indexOf("//") === 0 ? "https:" + u : u) : ""; }
    var imgs = (p.images && p.images.length ? p.images.slice() : [p.featured_image]).filter(Boolean).map(norm);
    CUR.images = imgs;

    // blocs levés de la fiche produit
    function lift(sel) { var e = doc && doc.querySelector(sel); return e ? e.outerHTML : ""; }
    var titleHTML = lift(".product-title") || ('<h1 class="product-title uppercase--false">' + p.title + '</h1>');
    var badgeHTML = lift(".product-best-seller-badge");
    var socialHTML = lift(".eut-social-proof");

    // map couleurs (classe + --option-color) depuis la fiche produit
    var colorMap = {};
    if (doc) {
      var cfs = doc.querySelector(".product-form__input--color");
      if (cfs) [].slice.call(cfs.querySelectorAll("label[for]")).forEach(function (l) {
        var inp = doc.getElementById(l.getAttribute("for"));
        if (inp) colorMap[inp.value] = { cls: l.className, style: l.getAttribute("style") || "" };
      });
    }

    var html = "";
    // media carousel
    html += '<div class="euq-media"><div class="euq-track" id="euq-track">' +
            imgs.map(function (u) { return '<div class="euq-slide"><img src="' + u + '" alt="" loading="lazy"></div>'; }).join("") +
            '</div>' +
            (imgs.length > 1 ? '<button class="euq-nav euq-prev" type="button" aria-label="Photo précédente">‹</button><button class="euq-nav euq-next" type="button" aria-label="Photo suivante">›</button><div class="euq-progress"><span class="euq-progress__bar"></span></div>' : '') +
            '</div>';
    // info
    html += '<div class="euq-info">';
    if (p.type) html += '<div class="euq-eyebrow">' + String(p.type).toUpperCase() + '</div>';
    html += '<a class="euq-title-link" href="/products/' + p.handle + '">' + titleHTML + '</a>';
    html += badgeHTML;
    html += socialHTML;
    html += '<div class="product-price-container" id="euq-price"></div>';
    // options
    (p.options || []).forEach(function (opt, idx) {
      var name = opt.name || ("Option " + (idx + 1));
      if (isColorOpt(name)) {
        html += '<div class="euq-opt" data-optidx="' + idx + '">' +
                '<div class="euq-opt__label">' + name + ' : <b class="euq-optval" data-optidx="' + idx + '">' + sel[idx] + '</b></div>' +
                '<div class="euq-sw">' + opt.values.map(function (val) {
                  return '<button type="button" class="' + swatchClass(val, colorMap) + '" data-optidx="' + idx + '" data-val="' + encodeURIComponent(val) + '" title="' + val + '" style="--option-color:' + swatchColor(val, colorMap) + '" aria-pressed="' + (val === sel[idx]) + '"></button>';
                }).join("") + '</div></div>';
      } else {
        html += '<div class="euq-opt" data-optidx="' + idx + '">' +
                '<div class="euq-opt__label">' + name + ' : <b class="euq-optval" data-optidx="' + idx + '">' + sel[idx] + '</b></div>' +
                '<div class="euq-pills">' + opt.values.map(function (val) {
                  return '<button type="button" data-optidx="' + idx + '" data-val="' + encodeURIComponent(val) + '" aria-pressed="' + (val === sel[idx]) + '">' + val + '</button>';
                }).join("") + '</div></div>';
      }
    });
    // actions : bouton fiche (trait pour trait via .eut-add) + coeur wishlist ; PAS de stepper, PAS de "voir details"
    html += '<div class="euq-actions">' +
              '<button type="button" class="button single-add-to-cart-button" id="euq-add"><span class="single-add-to-cart-button--text" data-content="Ajouter au panier"></span></button>' +
              '<button class="wishlist-btn wishlist-btn--pdp" type="button" data-wishlist-btn data-product-id="' + p.id + '" data-product-handle="' + p.handle + '" data-product-title="' + String(p.title).replace(/"/g, "&quot;") + '" data-product-image="' + (imgs[0] || "") + '" data-product-price="' + euros(first.price) + '" aria-label="Ajouter à la wishlist" aria-pressed="false">' +
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>' +
              '</button>' +
            '</div>';
    html += '</div>';

    body.innerHTML = html;
    wire();
    refresh();
  }

  function refresh() {
    var p = CUR.product, sel = CUR.selected;
    var v = findVariant(p, sel); CUR.variant = v;
    var cents = v ? v.price : p.price, cmp = v ? v.compare_at_price : p.compare_at_price;
    var priceEl = body.querySelector("#euq-price"); if (priceEl) priceEl.innerHTML = priceMarkup(cents, cmp);
    body.querySelectorAll(".euq-optval").forEach(function (b) { b.textContent = sel[+b.dataset.optidx]; });
    body.querySelectorAll(".euq-sw button").forEach(function (b) {
      b.setAttribute("aria-pressed", decodeURIComponent(b.dataset.val) === sel[+b.dataset.optidx] ? "true" : "false");
    });
    body.querySelectorAll(".euq-pills button").forEach(function (b) {
      var idx = +b.dataset.optidx, val = decodeURIComponent(b.dataset.val);
      b.setAttribute("aria-pressed", val === sel[idx] ? "true" : "false");
      b.disabled = !optionAvailable(p, idx, val, sel);
    });
    // image variant -> scroll carousel
    if (v && v.featured_image && v.featured_image.src) {
      var track = body.querySelector("#euq-track");
      if (track && CUR.images && CUR.images.length) {
        var vs = v.featured_image.src.split("?")[0];
        var i = CUR.images.map(function (u) { return u.split("?")[0]; }).indexOf(vs);
        if (i >= 0 && track.clientWidth) track.scrollTo({ left: i * track.clientWidth, behavior: "smooth" });
      }
    }
    var add = body.querySelector("#euq-add");
    if (add && !add.dataset.busy) {
      if (!v || !v.available) { add.disabled = true; setAddLabel(add, v ? "Rupture de stock" : "Indisponible"); }
      else { add.disabled = false; setAddLabel(add, "Ajouter au panier"); }
    }
  }

  function wire() {
    // carousel
    var track = body.querySelector("#euq-track");
    if (track) {
      var prev = body.querySelector(".euq-prev"), next = body.querySelector(".euq-next"),
          bar = body.querySelector(".euq-progress__bar"), nSlides = body.querySelectorAll(".euq-slide").length;
      function go(dir) {
        var w = track.clientWidth || 1, atEnd = track.scrollLeft >= track.scrollWidth - w - 4, atStart = track.scrollLeft <= 4;
        var to = dir > 0 ? (atEnd ? 0 : track.scrollLeft + w) : (atStart ? (nSlides - 1) * w : track.scrollLeft - w);
        track.scrollTo({ left: to, behavior: "smooth" });
      }
      if (prev) prev.addEventListener("click", function () { go(-1); stopAuto(); });
      if (next) next.addEventListener("click", function () { go(1); stopAuto(); });
      var syncing;
      function syncNav() {
        var w = track.clientWidth || 1, i = Math.min(nSlides - 1, Math.round(track.scrollLeft / w));
        if (bar) { bar.style.width = ((i + 1) / nSlides * 100) + "%"; }
      }
      track.addEventListener("scroll", function () { if (syncing) cancelAnimationFrame(syncing); syncing = requestAnimationFrame(syncNav); });
      setTimeout(syncNav, 60);
      // défilement auto toutes les 2s (boucle) ; STOP définitif dès que l'user clique une flèche ou scrolle les images
      function startAuto() { clearInterval(autoTimer); autoTimer = setInterval(function () { go(1); }, 2000); }
      function stopAuto() { clearInterval(autoTimer); }
      startAuto();
      ["wheel", "touchstart", "pointerdown", "mousedown"].forEach(function (ev) { track.addEventListener(ev, stopAuto, { passive: true }); });
    }
    // swatches couleur
    body.querySelectorAll(".euq-sw button").forEach(function (b) {
      b.addEventListener("click", function () { CUR.selected[+b.dataset.optidx] = decodeURIComponent(b.dataset.val); refresh(); });
    });
    // pills quantité
    body.querySelectorAll(".euq-pills button").forEach(function (b) {
      b.addEventListener("click", function () { if (b.disabled) return; CUR.selected[+b.dataset.optidx] = decodeURIComponent(b.dataset.val); refresh(); });
    });
    // qty
    var qty = body.querySelector("#euq-qty");
    if (qty) {
      body.querySelectorAll(".euq-qty button").forEach(function (b) { b.addEventListener("click", function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + (+b.dataset.q)); }); });
      qty.addEventListener("change", function () { qty.value = Math.max(1, parseInt(qty.value, 10) || 1); });
    }
    body.querySelector("#euq-add").addEventListener("click", addToCart);
  }

  function setAddLabel(add, txt) { var s = add.querySelector(".single-add-to-cart-button--text"); if (s) s.setAttribute("data-content", txt); else add.textContent = txt; }
  function addToCart() {
    var add = body.querySelector("#euq-add"), v = CUR.variant;
    if (!v || !v.available || add.dataset.busy) return;
    var qEl = body.querySelector("#euq-qty"), qty = qEl ? Math.max(1, parseInt(qEl.value, 10) || 1) : 1;
    add.dataset.busy = "1"; add.disabled = true; setAddLabel(add, "…");
    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ id: v.id, quantity: qty }) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () {
        setAddLabel(add, "Ajouté ✓");
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        setTimeout(function () { delete add.dataset.busy; close(); var t = document.querySelector(".thb-secondary-cart,[href=\"/cart\"],a[href*=\"/cart\"]"); if (t) t.click(); }, 550);
      })
      .catch(function () { delete add.dataset.busy; add.disabled = false; setAddLabel(add, "Réessayer"); });
  }

  /* ---------- Interception + préchargement au survol (desktop = ouverture instantanée, sans spinner) ---------- */
  function handleFor(el) { var qv = el.closest && el.closest("quick-view[data-product-handle],[data-quick-view-handle]"); return qv ? (qv.getAttribute("data-product-handle") || qv.getAttribute("data-quick-view-handle")) : null; }
  var CACHE = {};
  function loadProduct(handle) {
    if (CACHE[handle]) return CACHE[handle];
    var entry = { p: null, doc: null };
    entry.promise = Promise.all([
      fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }),
      fetch("/products/" + handle, { headers: { Accept: "text/html" } }).then(function (r) { return r.text(); }).catch(function () { return ""; })
    ]).then(function (res) { entry.p = res[0]; entry.doc = res[1] ? new DOMParser().parseFromString(res[1], "text/html") : null; return entry; });
    CACHE[handle] = entry;
    return entry;
  }
  // précharge dès que la souris survole (desktop) OU que le doigt touche la carte (mobile) -> données prêtes avant le clic
  function prefetchFrom(t) {
    if (!t || !t.closest) return;
    var h = handleFor(t);
    if (!h) { var card = t.closest("product-card, .product-card, .card"); if (card) { var qv = card.querySelector("quick-view[data-product-handle]"); if (qv) h = qv.getAttribute("data-product-handle"); } }
    if (h) loadProduct(h);
  }
  document.addEventListener("mouseover", function (e) { prefetchFrom(e.target); }, { passive: true });
  document.addEventListener("touchstart", function (e) { prefetchFrom(e.target); }, { passive: true });
  var SPIN = '<div style="padding:60px;flex:1;display:flex;align-items:center;justify-content:center"><span class="euq-spin" style="border-color:rgba(0,0,0,.2);border-top-color:#141414;width:26px;height:26px"></span></div>';
  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    var handle = handleFor(e.target); if (!handle) return;
    e.preventDefault(); e.stopImmediatePropagation();
    open();
    var entry = loadProduct(handle);
    if (entry.p) { render(entry.p, entry.doc); return; } // déjà préchargé -> instantané, aucun spinner
    if (body) body.innerHTML = ""; // pas d'ancien contenu ; spinner seulement si ça traîne (>300ms, masqué par l'anim d'ouverture)
    var spinT = setTimeout(function () { if (body && !body.querySelector(".euq-info")) body.innerHTML = SPIN; }, 300);
    entry.promise.then(function (en) { clearTimeout(spinT); render(en.p, en.doc); }).catch(function () { clearTimeout(spinT); close(); });
  }, true);
})();
